import { Checkbox, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import { grey } from "@mui/material/colors"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

export function GroupSelectorDialogItem({ item }) {
    const { childrenOf, selected, onToggle, onNavigate } = useBoundContext()
    const isVirtual = !!item?.isVirtual
    const hasChildren = isVirtual || (childrenOf?.get(item?.id) ?? []).length > 0
    const isSelected = !isVirtual && (selected ?? []).includes(item?.id)
    const folderIcon = isVirtual ? "material-symbols:folder" : "ic:twotone-folder"

    return (
        <ListItemButton
            onClick={hasChildren ? handleNavigate : handleToggle}
            sx={{ borderBottom: `1px solid ${grey[200]}`, minHeight: "50px" }}
            data-cy={`navigate-into-${item?.id}`}
        >
            <If truthy={!isVirtual}>
                <Checkbox
                    checked={isSelected}
                    size="small"
                    sx={{ mr: 0.5 }}
                    onClick={stopPropagation}
                    onChange={handleToggle}
                />
            </If>
            <ListItemIcon sx={{ minWidth: 32 }}>
                <Iconify icon={folderIcon} sx={{ color: "primary.main", width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary={item?.name} />
            <If truthy={hasChildren}>
                <Iconify icon="mdi:chevron-right" />
            </If>
        </ListItemButton>
    )

    function stopPropagation(e) {
        e.stopPropagation()
    }

    function handleToggle() {
        if (!isVirtual) onToggle(item.id)
    }

    function handleNavigate() {
        onNavigate(item.id)
    }
}
